module.exports = __webpack_public_path__ + "static/media/logo_qualdo-bix.6727bc23.svg";